import { customerMembers } from '../customerMember'
import { describeTable } from './describeTable'

describeTable(customerMembers, {
  description: `Links a person (users) to a customer account. Two independent axes: access_role says what the person may do in the apps (NULL = no access at all, the row is only a CRM contact), relationship_type says who they are to the customer (board chair, property manager …). A row must have at least one of the two. At most one live row per (customer, user).
The 'owner' is normally the person who first booked under that email and receives the invoices. Prospect-import contacts (isännöitsijät, board members from the Profinder / asoy data) have access_role NULL and are not app users. Join users for name, email, phone and the user's first-touch attribution.`,
  columns: {
    accessRole:
      'owner = full control of the account and the billing contact; member = can view and book; NULL = CRM contact only, no login access.',
    relationshipType:
      'CRM role: property_manager = isännöitsijä, board_chair = hallituksen puheenjohtaja, board = hallituksen jäsen, other. NULL for ordinary household members.',
    source:
      "Which import created the link, e.g. 'profinder'. NULL for onboarding, manual and the asoy import.",
    joinedAt:
      'When the person was attached; equals the import time for imported contacts.',
  },
})
